import React, { useState, useEffect } from 'react';
import Header from '../common/header';
import Sidebar from '../common/navBar';
import CommonCard from '../common/commonCard';
import { Container, Row, Col } from 'react-bootstrap';
import CustomTable from '../common/table';
import Footer from '../common/footer';
import { GetUsersService } from '../../Services/userService';
import { useTranslation } from 'react-i18next';

const Users = () => {
  const [t] = useTranslation("users")
  const [expanded, setExpanded] = useState(false);
  const [usersData, setUsersData] = useState([]);
  const [loading, setLoading] = useState(true);

  const columnHeaders = [
    `${t("usersTable.mail")}`,
    `${t("usersTable.nif")}`,
    `${t("usersTable.name")}`,
    `${t("usersTable.surname")}`,
    `${t("usersTable.rol")}`,
    `${t("usersTable.enabled")}`
  ];

  const Rols = [
    `${t("usersTableFilters.admin")}`,
    `${t("usersTableFilters.responsible")}`
  ];

  const enabled = [
    `${t("usersTableFilters.enabled")}`,
    `${t("usersTableFilters.disabled")}`
  ];

  const fieldsToShow = ['mail', 'nif', 'name', 'surname', 'rol', 'enabled'];
  const optionArrays = [[], [], [], [], Rols, enabled];


  async function fetchData() {
    setLoading(true)
    try {
      setUsersData([]);
      const response = await GetUsersService(t);
      setUsersData(response);
      setLoading(false)

    } catch (error) {
      setLoading(false)
      console.error('Hubo un error al obtener los datos de los usuarios', error);
    }
  }

  const handleReloadData = () => {

    fetchData();
  };

  useEffect(() => {

    fetchData();
  }, []);

  return (
    <div>
      <Header
        manual={'https://www.myreportin.com/descargas/manual-de-usuario-Myreportin.pdf'}
        reloadData={handleReloadData}
      />
      <Container fluid>
        <Row>
          <Col className='d-flex' style={{ paddingLeft: 0, paddingRight: 0, flex: `0 0 ${expanded ? '2%' : '4%'}` }}>
            <Sidebar expanded={expanded} setExpanded={setExpanded} selected={'Usuarios'} />
          </Col>
          <Col className='custom-content-wrapper' style={{ marginLeft: `0.5%`, paddingRight: 0, flex: `0 0 ${expanded ? '88%' : '93%'}` }}>

            <CommonCard title={t("card.title")} icon={'FaUsers'}>
              <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between' }}>
                <CustomTable
                  key={loading}
                  columnHeaders={columnHeaders}
                  fieldsToShow={fieldsToShow}
                  data={usersData}
                  showNewButton
                  NewButtonRoute={"/create-user"}
                  navigateTo={'/edit-user'}
                  optionArrays={optionArrays}
                  dataType={'users'}
                  loading={loading}
                  doubleButton
                />
              </div>
            </CommonCard>
            <Footer />
          </Col>

        </Row>
      </Container>
    </div>
  );
}

export default Users;